"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.monedas = void 0;
exports.monedas = {
    UYU: "$",
    EUR: "€",
    USD: "USD",
    ARS: "ARS",
    R$: "R$",
    "DLS.": "DLS.",
    U$A: "U$A",
    UYI: "UI - Unidad indexada",
    UYR: "U.R.",
    AUD: "AUD",
    BRL: "R$",
    CLP: "CLP",
    NZD: "NZD",
    ZAR: "R",
    DKK: "kr",
    CAD: "CAD",
    GBP: "£",
    JPY: "¥",
    PEN: "S/.",
    CNY: "¥",
    CNH: "¥",
    MXN: "MXN",
    HUF: "Ft",
    TRY: "₺",
    NOK: "kr",
    PYG: "₲",
    ISK: "kr",
    HKD: "$",
    KRW: "V",
    RUB: "₽",
    COP: "$",
    MYR: "RM",
    INR: "₹",
    SEK: "kr",
    CHF: "CHF",
    VEF: "Bs.S"
};
